export const SETTINGS_PAGES = {
  company: 'company',
  companySettings: 'companySettings',
  userManagement: 'userManagement',
  permissionGroups: 'permissionGroups',
  permissionGroupsEdit: 'permissionGroupsEdit',
  userProfile: 'userProfile',
  holidayManager: 'holidayManager',
  interfaces: 'interfaces',
};
